import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=47da9823&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=47da9823&prod&lang=css"
import style1 from "./profile.vue?vue&type=style&index=1&id=47da9823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da9823",
  null
  
)

export default component.exports